import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import DriversMain from '../../components/drivers/DriversMain'
export default function DriverPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <DriversMain/>
        </>
    )
}